import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { RadioOption } from '../../models/radio-option';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrl: './radio-group.component.scss',
  standalone: false,
})
export class RadioGroupComponent<T> implements /*OnInit,*/ OnChanges {
  @Input() options: RadioOption<T>[] = [];
  @Input() groupId: string = '';
  @Input() selected?: RadioOption<T>;
  @Input() mode?: 'sort' | 'input' = 'input';

  formattedOptions: Map<string, RadioOption<T>[]> = new Map();

  @Output() optionChanged = new EventEmitter<RadioOption<T>>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.formatOptions();
    }
  }

  onStateChanged(value: RadioOption<T>) {
    this.selected = value;
    this.optionChanged.emit(this.selected);
  }

  getCurrentState(item: RadioOption<T>) {
    if (this.mode === 'input') {
      return item.value === this.selected;
    }

    return item.value === this.selected?.value && item.key === this.selected?.key
  }

  formatOptions() {
    for (const option of this.options) {
      const title = option.title || '';
      if (!this.formattedOptions.has(title)) {
        this.formattedOptions.set(title, []);
      }
      this.formattedOptions.get(title)?.push(option);
    }
  }
}
